(() => {
  const bar = document.querySelector('.page-announcement');
  if (!bar) return;

  const mobile = window.matchMedia('(max-width: 749px)');
  let previousPosition = window.scrollY;
  let direction = 0;
  let distance = 0;
  let transitionTimer = 0;

  const reset = (position) => {
    previousPosition = position;
    direction = 0;
    distance = 0;
  };

  const setCollapsed = (collapsed) => {
    if (bar.classList.contains('is-collapsed') === collapsed) return;
    bar.classList.toggle('is-collapsed', collapsed);
    window.clearTimeout(transitionTimer);
    transitionTimer = window.setTimeout(() => {
      transitionTimer = 0;
      reset(window.scrollY);
    }, 300);
  };

  document.addEventListener('theme:scroll', (event) => {
    if (!mobile.matches) return;

    const position = event.detail?.position ?? window.scrollY;
    const maxPosition = Math.max(0, document.documentElement.scrollHeight - window.innerHeight);
    const barHeight = Math.max(32, bar.scrollHeight);

    if (position <= 0) {
      setCollapsed(false);
      reset(0);
      return;
    }

    if (transitionTimer || position >= maxPosition - barHeight * 2) {
      reset(position);
      return;
    }

    const delta = position - previousPosition;
    previousPosition = position;
    const nextDirection = Math.sign(delta);
    if (!nextDirection) return;

    if (nextDirection !== direction) {
      direction = nextDirection;
      distance = 0;
    }

    distance += Math.abs(delta);
    if (distance >= barHeight) {
      setCollapsed(nextDirection > 0);
      distance = 0;
    }
  });

  mobile.addEventListener('change', () => {
    if (!mobile.matches) setCollapsed(false);
    reset(window.scrollY);
  });
})();
